// extracted by mini-css-extract-plugin
export default {"base":"SignInFailed__base___2YJFY","description":"SignInFailed__description___Cuk3r"};